import ApiService from './ApiService'
import {
  InvestorCredential,
  DashboardData
} from '@/@types/home'

export async function apiAddInvestor(data: InvestorCredential) {
  return ApiService.fetchData({
    url: '/api/investor',
    method: 'post',
    data,
  })
}

export async function apiGetDashboardData() {
  return ApiService.fetchData<DashboardData>({
    url: '/api/home/data',
    method: 'get'
  })
}